// extracted by mini-css-extract-plugin
export var buttonClean = "SocialShareButtons-module--buttonClean--a3c19";
export var placeholder = "SocialShareButtons-module--placeholder--d2f75";
export var publicationDate = "SocialShareButtons-module--publicationDate--93542";
export var shareButtonsContainer = "SocialShareButtons-module--shareButtonsContainer--71734";
export var socialMediaLink = "SocialShareButtons-module--socialMediaLink--e9e2a";
export var socialShareButtonsContainer = "SocialShareButtons-module--socialShareButtonsContainer--a11a9";
export var socialshareButtonsPlain = "SocialShareButtons-module--socialshareButtonsPlain--6d475";